/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cmd_MilestoneInputs */

const en_cmd_milestone = /** @type {(inputs: Cmd_MilestoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Set milestone`)
};

const de_cmd_milestone = /** @type {(inputs: Cmd_MilestoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meilenstein setzen`)
};

/**
* | output |
* | --- |
* | "Set milestone" |
*
* @param {Cmd_MilestoneInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const cmd_milestone = /** @type {((inputs?: Cmd_MilestoneInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cmd_MilestoneInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_cmd_milestone(inputs)
	return en_cmd_milestone(inputs)
});